<template>
  <div class="login">
    <div class="pc">
      <div class="loginTop">
        <div class="loginLogo warp">
          <div class="leftBox">
            <div class="loginImgBox">
              <img src="@/assets/images/yujian-logo.jpg" alt="遇健海南">
            </div>
            <div class="brandWords">
              <strong>遇健海南</strong>
              <span>商户合作平台</span>
            </div>
          </div>
          <!-- <div class="rightBox" v-if="userName !== ''">
            欢迎您{{userName == 'undefined' ? '' : userName}}
          </div>
          <div v-else class="rightBox">
            我已有CERESHOP<span>快捷登录</span>
          </div> -->
        </div>
      </div>
      <div class="loginCent">
        <div class="heroGlow heroGlowOne"></div>
        <div class="heroGlow heroGlowTwo"></div>
        <div class="entrance warp">
          <div class="entranceInfo">
            <div class="eyebrow">YU JIAN HAINAN PARTNER</div>
            <h1>一起，把海南的美好<br><em>分享给更多人</em></h1>
            <p>面向康养、文旅、酒店、餐饮及优质服务商户开放入驻，加入遇健海南，共建值得信赖的健康旅居服务生态。</p>
            <div class="featureList">
              <span>品牌联合推广</span><span>平台流量扶持</span><span>专业运营服务</span>
            </div>
          </div>
          <div class="applyPanel">
            <div class="panelHead">
              <div><strong>选择入驻类型</strong><span>请根据营业主体选择，资料可稍后完善</span></div>
              <b>预计 3–5 分钟</b>
            </div>
            <div class="entranceBtn">
            <div
              class="btnContainer"
              v-for="item in pcBtnList"
              :key="item.value"
              @click="goToApplication(type = item.type)"
            >
              <div class="iconBox"><img :src="item.img" alt=""></div>
              <div class="typeInfo"><strong>{{ item.label }}</strong><span>{{ item.desc }}</span></div>
              <i>→</i>
            </div>
            </div>
            <div class="process"><span>提交资料</span><i></i><span>平台审核</span><i></i><span>成功入驻</span></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="wap">
      <div class="wapTop">
        <img src="@/assets/images/yujian-logo.jpg" alt="遇健海南">
        <div><strong>遇健海南</strong><span>商户入驻</span></div>
      </div>
      <div class="wapBan">
        <div class="eyebrow">PARTNER WITH US</div>
        <h1>遇见好生意<br><em>共建海南康养生态</em></h1>
        <p>选择您的主体类型，快速提交入驻申请</p>
      </div>
      <div class="wapCent">
        <div class="wapCentBox">
          <div class="wapItemBox"
            v-for="item in mbBtnList"
            :key="item.value">
            <span>
              <span class="wapIcon"><img :src="item.img"></span>
              <span class="wapType"><strong>{{ item.label }}</strong><small>{{ item.desc }}</small></span>
            </span>
            <el-button @click="goToApplication(type = item.type)" type="primary">申请 <b>→</b></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Decrypt } from '@/util/secret.js'
import Cookie from 'js-cookie'
export default {
  name: 'login',
  data () {
    return {
      userName: '',
      // pc端列表渲染
      pcBtnList: [
        {
          value: 0,
          img: 'static/imgs/pc/pc-personal.svg',
          label: '个人商户',
          desc: '个人提供服务，无需营业执照',
          type: 'personal'
        },
        {
          value: 1,
          img: 'static/imgs/pc/pc-IndividualBusiness.svg',
          label: '个体工商户',
          desc: '持有个体工商户营业执照',
          type: 'IndividualBusiness'
        },
        {
          value: 2,
          img: 'static/imgs/pc/pc-enterprisesApply.svg',
          label: '企业商户',
          desc: '企业或公司主体申请入驻',
          type: 'enterprisesApply'
        },
        {
          value: 3,
          img: 'static/imgs/pc/pc-organization.svg',
          label: '其他组织',
          desc: '事业单位及其他组织主体',
          type: 'organization'
        }
      ],
      // 手机端列表渲染
      mbBtnList: [
        {
          value: 0,
          img: 'static/imgs/mb/mb-personal.svg',
          label: '个人商户',
          desc: '无需营业执照',
          type: 'mPersonal'
        },
        {
          value: 1,
          img: 'static/imgs/mb/mb-mUinitBusiness.svg',
          label: '个体工商户',
          desc: '个体营业执照主体',
          type: 'mUinitBusiness'
        },
        {
          value: 2,
          img: 'static/imgs/mb/mb-mEnterprise.svg',
          label: '企业商户',
          desc: '企业或公司主体',
          type: 'mEnterprise'
        },
        {
          value: 3,
          img: 'static/imgs/mb/mb-mOtherOrg.svg',
          label: '其他组织',
          desc: '机构及其他组织',
          type: 'mOtherOrg'
        }
      ]
    }
  },
  created () {
    if (this.userName === '') {
      let data = this.getQueryString('user')
      if (data !== '' && data !== undefined) {
        let user = Decrypt(data)
        console.log(user, 'token')
        Cookie.set('token', user)
      }
      // let userName = this.getQueryString('username')
      // let userInfo = decodeURI(userName)
      // if (userInfo !== '') {
      //   this.setUserName(userInfo)
      // }
    }
  },
  methods: {
    goToApplication (type) {
      if (type === 'IndividualBusiness') {
        this.$router.push({path: '/individualBusiness'})
      }
      if (type === 'personal') {
        this.$router.push({path: '/personal'})
      }
      if (type === 'enterprisesApply') {
        this.$router.push({path: '/enterprisesApply'})
      }
      if (type === 'organization') {
        this.$router.push({path: '/organization'})
      }
      if (type === 'mUinitBusiness') {
        this.$router.push({path: '/mUinitBusiness'})
      }
      if (type === 'mEnterprise') {
        this.$router.push({path: '/mEnterprise'})
      }
      if (type === 'mPersonal') {
        this.$router.push({path: '/mPersonal'})
      }
      if (type === 'mOtherOrg') {
        this.$router.push({path: '/mOtherOrg'})
      }
    },
    getQueryString (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const urlObj = window.location
      const url = window.location.href
      if (url.indexOf(name) !== -1) {
        let r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split('?')[1].match(reg) : urlObj.search.substr(1).match(reg)
        if (r != null) return unescape(r[2]); return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  min-height: 870px;
  display: flex;
  flex-direction: column;
  background-color: #123F39;
  background-image: linear-gradient(135deg, #0c3630 0%, #195249 58%, #123f39 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .loginTop {
    background-color: rgba(10, 43, 39, .92);
    border-bottom: 1px solid rgba(255,255,255,.1);
    position: relative;
    z-index: 999;
    .loginLogo {
      height: 50px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 180px;
        margin-right: 30px;
      }
      span {
        font-size: 18px;
        color: $fontColor;
      }
      .loginImgBox {
        width: 42px;
        height: 42px;
        align-items: center;
        display: flex;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .leftBox {
        display: flex;
        align-items: center;
        font-weight: 400;
      }
      .brandWords {
        display: flex;
        flex-direction: column;
        strong { font-size: 18px; color: #FFF; letter-spacing: 2px; }
        span { margin-top: 2px; font-size: 11px; color: #E9D39D; letter-spacing: 3px; }
      }
      .rightBox {
        font-size: 16px;
        span {
          color: #C5AA7B;
          padding-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .loginCent {
    margin-top: 100px;
    font-family: Microsoft YaHei;
    display: flex;
    justify-content: center;
    align-items: center;
    .entrance {
      .entranceInfo{
        .settleTitle {
          color: #FFFFFF;
          font-size: 42px;
          font-weight: 600;
          text-align: center;
          letter-spacing: 5px;
        }
        .settleLine {
          width: 56px;
          height: 3px;
          margin: 20px auto 0;
          border-radius: 3px;
          background: #DDBE73;
        }
        img{
          display: block;
          width: 480px;
          margin: auto;
        }
        p{
          margin: 30px 0;
          font-size: 16px;
          text-align: center;
          color: #FFFFFF;
        }
      }
    }
    .entranceBtn {
      width: 700px;
      display: flex;
      justify-content: space-around;
      .btnContainer{
        width: 80px;
        cursor: pointer;
        img{
          display: block;
          width: 80px;
          height: 80px;
        }
        span{
          display: block;
          margin-top: 18px;
          text-align: center;
          color: #FFEBC4;
          font-weight: 500;
        }
      }
    }
  }
  .wap {
    display: none;
  }
  .pc {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 768px;
  }
}
@media screen and (max-width: 750px) {
  .warp {
    width: 100%;
  }
  .login {
    background: #F8F8F8;
    position: relative;

    .pc {
      display: none;
    }

    .wap {
      display: block;

      .wapTop {
        height: 68px;
        color: #FFF;
        background: #174C45;
        display: flex;
        align-items: center;
        justify-content: center;
        img { width: 42px; height: 42px; border-radius: 50%; object-fit: cover; margin-right: 12px; }
        div { display: flex; flex-direction: column; text-align: left; }
        strong { font-size: 17px; letter-spacing: 2px; }
        span { margin-top: 3px; color: #F0D99F; font-size: 11px; letter-spacing: 3px; }
      }
      .wapBan {
        width: 100%;
        background: url("../../assets/images/mb-background.png") no-repeat top center;
        background-size: contain;
        height: 300px;
      }
      .wapCent {
        position: absolute;
        top: 25%;
        width: 100%;
        .wapCentBox {
          width: 94%;
          margin: -50px auto 0 auto;
          padding: 5%;
          background: #FFFFFF;
          // box-shadow: 0px 1px 32px 2px #F4F4F4;
          // border-radius: 10px;
          .wapItemBox {
            display: flex;
            height: 90px;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            border-bottom: 1px solid #F6F4F7;
            >>> .el-button--primary {
              width: 80px;
              color: #FFEBC4;
              background-color: #174C45;
              border-color: #174C45;
              border-radius: 18px;
            }
          }
          .wapItemBox:last-child {
            border-bottom: none;
          }
          span {
            display: flex;
            align-items: center;
            img {
              width: 35px;
              height: 35px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }
}
/* 遇健海南商户入驻首页 2026 视觉升级 */
.login {
  min-height: 100vh;
  background: #0d3b36;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  .pc { min-height: 100vh; }
  .loginTop {
    position: relative; z-index: 10; background: rgba(7, 42, 38, .78);
    border-bottom: 1px solid rgba(255,255,255,.1); backdrop-filter: blur(12px);
    .loginLogo { height: 76px; }
    .loginLogo .loginImgBox { width: 48px; height: 48px; margin-right: 14px; }
    .loginLogo .brandWords strong { font-size: 19px; }
  }
  .loginCent {
    min-height: calc(100vh - 77px); margin-top: 0; position: relative; overflow: hidden;
    background: radial-gradient(circle at 12% 18%, rgba(39,124,108,.52), transparent 34%), linear-gradient(135deg, #0b3732 0%, #12473f 58%, #092f2c 100%);
    &:after { content: ""; position: absolute; right: -160px; bottom: -260px; width: 620px; height: 620px; border: 1px solid rgba(225,197,127,.16); border-radius: 50%; box-shadow: 0 0 0 90px rgba(255,255,255,.018), 0 0 0 180px rgba(255,255,255,.012); }
    .heroGlow { position: absolute; border-radius: 50%; }
    .heroGlowOne { width: 280px; height: 280px; left: -100px; bottom: 5%; background: rgba(222,190,115,.08); }
    .heroGlowTwo { width: 14px; height: 14px; left: 44%; top: 18%; background: #dbbb70; box-shadow: 0 0 40px 14px rgba(219,187,112,.2); }
    .entrance { position: relative; z-index: 2; display: grid; grid-template-columns: .92fr 1.08fr; gap: 72px; align-items: center; padding-top: 56px; padding-bottom: 56px; }
    .entranceInfo {
      color: #fff;
      .eyebrow { color: #dfc47f; font-size: 12px; letter-spacing: 4px; margin-bottom: 24px; }
      h1 { margin: 0; font-size: 48px; line-height: 1.38; font-weight: 500; letter-spacing: 2px; }
      h1 em { color: #f0d691; font-style: normal; }
      p { max-width: 520px; margin: 26px 0; color: rgba(255,255,255,.72); line-height: 2; font-size: 15px; text-align: left; }
      .featureList { display: flex; flex-wrap: wrap; gap: 10px; }
      .featureList span { padding: 8px 14px; border: 1px solid rgba(235,211,153,.3); border-radius: 20px; color: #ead9ad; font-size: 12px; background: rgba(255,255,255,.04); }
    }
    .applyPanel { padding: 34px; border-radius: 24px; background: rgba(255,255,255,.97); box-shadow: 0 28px 80px rgba(0,20,18,.3); }
    .panelHead { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 22px; border-bottom: 1px solid #edf0ee;
      div { display: flex; flex-direction: column; }
      strong { color: #183f3a; font-size: 22px; }
      span { color: #96a19e; font-size: 12px; margin-top: 9px; }
      b { color: #a68136; background: #fbf6e9; border-radius: 20px; padding: 7px 11px; font-size: 11px; font-weight: 400; }
    }
    .entranceBtn { width: auto; display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-top: 22px;
      .btnContainer { width: auto; min-width: 0; cursor: pointer; display: flex; align-items: center; padding: 18px 15px; border: 1px solid #e7ecea; border-radius: 14px; transition: .25s ease; background: #fff;
        &:hover { transform: translateY(-3px); border-color: #cdb46f; box-shadow: 0 12px 26px rgba(21,70,62,.1); }
        .iconBox { flex: none; width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-radius: 13px; background: #eef7f4; }
        .iconBox img { width: 34px; height: 34px; }
        .typeInfo { min-width: 0; flex: 1; display: flex; flex-direction: column; margin-left: 12px; }
        .typeInfo strong { color: #20433e; font-size: 15px; }
        .typeInfo span { display: block; margin-top: 6px; color: #9aa3a1; font-size: 11px; text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        > i { color: #c4a85f; font-style: normal; font-size: 19px; margin-left: 6px; }
      }
    }
    .process { margin-top: 24px; padding-top: 20px; border-top: 1px solid #edf0ee; display: flex; align-items: center; justify-content: center; color: #8b9794; font-size: 11px;
      i { width: 42px; height: 1px; margin: 0 10px; background: #ddd5bd; position: relative; }
    }
  }
}

@media screen and (max-width: 750px) {
  .login {
    min-height: 100vh; background: #f3f6f5;
    .wap .wapTop { height: 64px; background: #123f39;
      img { width: 40px; height: 40px; margin-right: 10px; }
      strong { font-size: 16px; }
    }
    .wap .wapBan { height: 235px; padding: 40px 24px 0; box-sizing: border-box; color: #fff; background: radial-gradient(circle at 90% 10%, rgba(226,195,119,.25), transparent 32%), linear-gradient(145deg, #164e46, #0b3531);
      .eyebrow { color: #dbc078; font-size: 10px; letter-spacing: 3px; }
      h1 { margin: 14px 0 0; font-size: 27px; line-height: 1.45; letter-spacing: 1px; font-weight: 500; }
      em { color: #efd590; font-style: normal; }
      p { margin-top: 12px; color: rgba(255,255,255,.65); font-size: 12px; }
    }
    .wap .wapCent { position: relative; z-index: 2; top: auto; margin-top: -34px; padding-bottom: 28px;
      .wapCentBox { width: calc(100% - 28px); box-sizing: border-box; margin: 0 auto; padding: 8px 18px; background: #fff; border-radius: 18px; box-shadow: 0 14px 40px rgba(16,61,54,.12); }
      .wapCentBox .wapItemBox { min-height: 88px; height: auto; border-bottom-color: #eef1f0;
        > span { min-width: 0; }
        >>> .el-button--primary { flex: none; width: 76px; height: 34px; padding: 0; color: #f6dfaa; background: #174c45; border-color: #174c45; border-radius: 17px; }
      }
      .wapCentBox .wapIcon { flex: none; width: 46px; height: 46px; justify-content: center; border-radius: 13px; background: #eef7f4; margin-right: 12px;
        img { width: 30px; height: 30px; margin: 0; }
      }
      .wapCentBox .wapType { min-width: 0; align-items: flex-start; flex-direction: column;
        strong { color: #23433f; font-size: 15px; }
        small { margin-top: 5px; color: #9aa4a1; font-size: 11px; white-space: nowrap; }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue